import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const ItalicIcon = (props) => {
  return (
 /*   <svg 
      className= {props.selected ? "svgEditorSelected": "svgEditor"}
      height="21"
      viewBox="0 0 48 48"
      width="21"
      onClick={props.onClick}
      style={ { paddingTop:"2px", paddingLeft:"2px" } }>
       <g>
      <line  fill="none" stroke="gray"  x1="19.8" x2="11.8" y1="6.6" y2="26.6"/>
      <line  fill="none" stroke="gray"  x1="14.7" x2="23.9" y1="6.6" y2="6.6"/>
      <line   fill="none" stroke="gray"  x1="8.1" x2="17.3" y1="26.6" y2="26.6"/>
      </g>
    </svg>
*/
<svg className= {props.selected ? "svgEditorSelected": "svgEditor"} version="1.0" xmlns="http://www.w3.org/2000/svg"
width="8.000000pt" height="8.000000pt" viewBox="0 0 512.000000 512.000000"
preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
 stroke="none">
<path d="M1830 4570 l0 -550 404 0 404 0 -626 -1460 -627 -1460 -507 0 -508 0
0 -550 0 -550 1460 0 1460 0 0 550 0 550 -404 0 -404 0 626 1460 627 1460 507
0 508 0 0 550 0 550 -1460 0 -1460 0 0 -550z"/>
</g>
</svg>
  );
};

export default ItalicIcon;
